import { Spin } from 'antd'
import React from 'react'
import Flex from '../../../components/Flex'
import CallIcon from '../../../components/icons/CallIcon'
import MailIcon from '../../../components/icons/MailIcon'

import { FolderSpinner } from '../../Placement/style'
import { ResumeDiv } from '../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import {
  CollegeName,
  DrawerHeader,
  HeaderFlexOne,
  InfoSection,
  StudentName,
} from '../../Students/Partials/StudentsInfoTable/ViewStudentDrawer/style'
import { MenuItem, OptedOutText, OptOutDiv, SectionNavMenu } from '../style'
import StudentResumeDetailsAction from './StudentResumeDetailsAction'
import StudentResumeDrawerContent from './StudentResumeDrawerContent'
import AvatarImage from 'components/Avatar'

const ViewResumeDrawer = ({
  viewDrawer,
  setViewDrawer,
  isLoading,
  setIsLoading,
  getPreviewData,
  previewData,
  roleID=""
}) => {
  const title = () => {
    return (
      <DrawerHeader flexWrap="wrap" gap="10px" centerVertically spaceBetween>
        <HeaderFlexOne centerVertically spaceBetween>
          <Flex wrap="wrap">
            <AvatarImage
              background
              src={previewData?.profileUrl}
              size={90}
              font={18}
              IconName={previewData?.firstName?.split('')?.[0]}
            />
            <InfoSection column center>
              <StudentName>
                {previewData?.firstName} {previewData?.lastName}
              </StudentName>
              <CollegeName>
                <MailIcon />
                {previewData?.admin?.email}
              </CollegeName>
              <CollegeName>
                <CallIcon />
                {previewData?.admin?.phone_number}
              </CollegeName>
            </InfoSection>
          </Flex>
        </HeaderFlexOne>
        <StudentResumeDetailsAction previewData={previewData} roleID={roleID} />
      </DrawerHeader>
    )
  }
  const content = () => {
    return <StudentResumeDrawerContent previewData={previewData} />
  }
  return (
    <>
      {isLoading ? (
        <FolderSpinner>
          <Spin />
        </FolderSpinner>
      ) : (
        <ResumeDiv>
          {title()}
          {(previewData?.currentCourse?.optOutStatus === 1 ||
            previewData?.currentCourse?.optOutStatus === 4) && (
            <OptOutDiv>
              <OptedOutText strong>
                This student has opted out from the Placement Process.{' '}
              </OptedOutText>
            </OptOutDiv>
          )}
          <SectionNavMenu mode="horizontal" defaultSelectedKeys={['Resume']}>
            <MenuItem key="Resume">Resume</MenuItem>
          </SectionNavMenu>
          {content()}
        </ResumeDiv>
      )}
    </>
  )
}
export default ViewResumeDrawer
